import "./LabelledItem.css";
import React from "react";
import PropTypes from "prop-types";
import Badge from "@material-ui/core/Badge";
import HeaderItem from "../../mixins/HeaderItem";
import { URLS } from "util/constants";
import classNames from "classnames";

class NotificationItem extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        notificationCount: PropTypes.number
    };

    render() {
        const innerProps = {
            className: classNames("label-link", this.props.className, { "has-icon": this.props.icon }),
            href: URLS.MEMBER.NOTIFICATIONS,
            onClick: this.handleClick
        };

        const badge = this.props.notificationCount <= 0
            ? null
            : (
                <Badge key="notification-badge" anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={this.props.notificationCount} color="error">
                    <i className="icon-bell" />
                </Badge>
            );

        return React.createElement(
            "a",
            innerProps,
            [
                badge,
                <span key="label" className="header-label">{"Notifications"}</span>
            ]);
    }
}

export default HeaderItem(NotificationItem, "labelled-item");
